import React, { useCallback, useEffect, useState } from "react";
import { Bot } from "lucide-react";
import { api } from "@/lib/api";

const fmtTs = (s) => (s ? new Date(s * 1000).toLocaleString() : "—");

export default function RoniModelPanel() {
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await api.get("/admin/roni/model");
      setData(r.data);
    } catch { /* silent */ }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [load]);

  if (!data) return null;
  const hasErr = !!data.provider_fail_count;
  return (
    <section data-testid="roni-model-panel" className="mt-6 rounded-2xl border border-propertic-line bg-white p-5 sm:p-6">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <span className={`mt-0.5 inline-flex h-9 w-9 items-center justify-center rounded-full ${hasErr ? "bg-amber-100 text-amber-700" : "bg-emerald-100 text-emerald-700"}`}>
            <Bot className="h-4 w-4" />
          </span>
          <div>
            <p className="text-[10px] uppercase tracking-[0.2em] text-propertic-muted">Roni AI model</p>
            <p data-testid="roni-active-model" className="mt-1 text-base font-medium text-propertic-ink">{data.active_label}</p>
            <p className="mt-1 text-xs text-propertic-muted">
              Emergent Universal Key. Backup: Claude Sonnet 4.6 (same key). Personal Google key retired. No live web search.
            </p>
            {hasErr && (
              <p data-testid="roni-provider-error" className="mt-1 text-[11px] text-propertic-muted break-all">
                Last provider error ({fmtTs(data.last_provider_error_at)}): {data.last_provider_error}. Check Universal Key balance / auto top-up.
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
